import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-catalog-brand))",
      d: "M10.62 1.2v8.82H1.8V3.84L4.812 1.2zm11.4 8.82H13.2V1.2h6.18l2.64 3.012zm-8.82 11.4V12.6h8.82v6.18l-3.012 2.64zM1.8 12.6h8.82v8.82H4.44L1.8 18.408z"
    }, null, -1)
  ]))]))
}
export default { render: render }